import { cn } from "@/lib/utils";

/**
 * Film-grain noise layer, ported from the Hype Stack storefront.
 *
 * Absolute (not fixed) so it stretches to the full scroll height of its
 * container and scrolls with the page. Sits above content with pointer-events
 * disabled so the grain is visible without blocking clicks.
 *
 * Light mode uses `multiply` - `overlay` is nearly invisible on cream page
 * backgrounds because the turbulence midtones cancel out. Dark mode keeps
 * `overlay`, which reads cleanly on near-black surfaces.
 */
const NOISE_TILE =
  "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='160' height='160' filter='url(%23n)'/%3E%3C/svg%3E\")";

const NOISE_STYLE = {
  backgroundImage: NOISE_TILE,
  backgroundRepeat: "repeat",
} as const;

export function PageNoise({ className }: { className?: string }) {
  return (
    <div
      aria-hidden
      className={cn(
        "pointer-events-none absolute inset-0 z-[1000] opacity-[0.2] mix-blend-multiply dark:opacity-70 dark:mix-blend-overlay",
        className,
      )}
      style={NOISE_STYLE}
    />
  );
}
